export default __webpack_public_path__ + "static/soehne-mono-web-leicht-kursiv-60444cad6a22c5248f52edc1bd07377d.woff2";